"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useAfterScrollPosition = ({ scrollTop }) => {
    const [isAfterPosition, setIsAfterPosition] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const onScroll = () => {
            const isAfterScrollPosition = document.documentElement.scrollTop >= scrollTop;
            setIsAfterPosition(isAfterScrollPosition);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [scrollTop]);
    return isAfterPosition;
};
exports.default = useAfterScrollPosition;
